import { Box, Container, Typography, Paper, Stack, Link } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ErrorFallback = ({ error }: { error: unknown }) => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: "100%",
            borderRadius: 2,
            bgcolor: "background.paper",
          }}
        >
          <Stack spacing={3} alignItems="center">
            <ErrorOutlineIcon color="error" sx={{ fontSize: 64 }} />

            <Typography variant="h4" component="h1" gutterBottom>
              Sorry, something went wrong.
            </Typography>

            <Typography variant="body1" color="text.secondary" align="center">
              We're sorry for the inconvenience. The error has been reported to our team.
            </Typography>

            {error instanceof Error && (
              <Box
                sx={{
                  width: "100%",
                  bgcolor: "grey.50",
                  p: 2,
                  borderRadius: 1,
                  maxHeight: "150px",
                  overflow: "auto",
                }}
              >
                <Typography
                  variant="body2"
                  component="pre"
                  sx={{
                    fontFamily: "monospace",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all",
                  }}
                >
                  {error.toString()}
                </Typography>
              </Box>
            )}

            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Need help? <Link href="mailto:success@unyte.com">Contact Support</Link>
              </Typography>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
};

export default ErrorFallback;
